import { Component, EventEmitter, Input, Output, ViewChild,
    ChangeDetectionStrategy
} from '@angular/core';
import { Popover } from '@openng/optimus-ui/popover';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'sm-color-editor',
    standalone: false,
    templateUrl: './color-editor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./color-editor.component.scss']
})
export class ColorEditorComponent
{

    _value: string;

    @Input()
    set value(value: number) {
        this._value = Utils.toColorHexString(value);
    }

    @Output()
    valueChange = new EventEmitter<number>();

    disabled = false;

    mode: 'preset' | 'advanced' = 'preset';

    presetColors = Utils.getMaterialColors().map(c => Utils.toColorHexString(c));

    @ViewChild("op")
    op: Popover;

    selectPreset(color: string): void
    {
        this.setColor(color);
        this.op.hide();
    }

    colorChanged(event: any): void
    {
        this.setColor(event.color.hex as string);   
    }

    private setColor(color: string): void
    {
        this._value = color;

        this.valueChange.emit(Utils.toColorNumber(color));
    }
}
